<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item label="所属工厂">
                    <el-select v-model="fcCode" placeholder="请选择工厂" :clearable="isclear" filterable :disabled="ischeck"
                               @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName"
                                   :value="factory.fcCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安灯类型">
                    <el-select v-model="atId" placeholder="请选择" clearable filterable @change="searchTable">
                        <el-option v-for="type in andonTypes" :key="type.atId" :label="type.atName"
                                   :value="type.atId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="安灯种类列表" ref="LabelContent">
            <div slot="btns">
                <el-button size="small" type="success" @click="showAndonTypetVisible()" v-for="acc in access"
                           v-if="acc == 'AC0001'"> 新增
                </el-button>
                <!--<el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                <el-button size="small" type="success" @click="exportAndonContent()">导出</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="fcName" label="所属工厂" width="300"/>
                <el-table-column prop="atName" label="安灯类型" show-overflow-tooltip/>
                <el-table-column prop="acName" label="安灯种类" show-overflow-tooltip/>
                <el-table-column prop="acCode" label="安灯种类编号" show-overflow-tooltip/>
                <el-table-column prop="checkLevel" sortable label="级别" show-overflow-tooltip/>
                <!--                <el-table-column prop="createUser" label="创建用户" show-overflow-tooltip />-->
                <el-table-column prop="isActive" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.isActive == true ? '启用' : '不启用' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <i class="editBtn iconfont u-youjianbianji"
                           @click="showAndonTypetVisible(scope.row.acId, scope.row.fcCode)" v-for="acc in access"
                           v-if="acc == 'AC0002'"/>
                        <i class="delBtn iconfont u-shanchu" @click="deleteAndonContent(scope.row)"
                           v-for="acc in access" v-if="acc == 'AC0003'"/>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog :title="title" :visible.sync="andonTypetVisible" :show-close="true" width="70%"
                   @close="closeAndonTypet">
            <el-form label-width="100px" size="small">
                <el-row :gutter="20">
                    <el-col :span="7">
                        <el-form-item label="所属工厂">
                            <el-select v-model="andonContent.fcCode" :disabled="true" placeholder="请选择工厂"
                                       @change="selectChange">
                                <el-option v-for="factory in factoryList" :key="factory.factoryId"
                                           :label="factory.fcName" :value="factory.fcCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="选择安灯类型:">
                            <el-select v-model="andonContent.atId" placeholder="请选择安灯类型" size="small"
                                       style="width: 200px">
                                <el-option v-for="(item, index) in andonTypes" :key="item.atId" :label="item.atName"
                                           :value="item.atId"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="安灯种类名称:">
                            <el-input size="small" v-model="andonContent.acName" placeholder="请输入安灯种类名称"
                                      style="width: 200px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="安灯种类编号:">
                            <el-input size="small" v-model="andonContent.acCode" style="width: 200px"
                                      :disabled="addAndonShow"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="验收等级:">
                            <el-select v-model="andonContent.checkLevel" @change="changeLevel" placeholder="请选择验收等级"
                                       size="small" style="width: 200px">
                                <el-option v-for="(item, index) in checkLevels" :key="item" :label="item"
                                           :value="item"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="是否有启用:">
                            <el-switch v-model="andonContent.isActive" active-color="#13ce66"
                                       inactive-color="#ff4949"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="7" v-if="show">
                        <el-form-item label="验收角色一:">
                            <el-select v-model="andonContent.roleId1" multiple placeholder="请选择角色" size="small"
                                       style="width: 200px" :disabled="andonRoleShow">
                                <el-option v-for="(item, index) in roleList" :key="item.roleId" :label="item.roleName"
                                           :value="item.roleId"/>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="7" v-if="show1">
                        <el-form-item label="验收角色二:">
                            <el-select v-model="andonContent.roleId2" multiple placeholder="请选择角色" size="small"
                                       style="width: 200px" :disabled="andonRoleShow">
                                <el-option v-for="(item, index) in roleList" :key="item.roleId" :label="item.roleName"
                                           :value="item.roleId"/>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="7" v-if="show2">
                        <el-form-item label="验收角色三:">
                            <el-select v-model="andonContent.roleId3" multiple placeholder="请选择角色" size="small"
                                       style="width: 200px" :disabled="andonRoleShow">
                                <el-option v-for="(item, index) in roleList" :key="item.roleId" :label="item.roleName"
                                           :value="item.roleId"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addAndonContent()">确 定</el-button>
                <el-button type="infor" @click="closeAndonTypet()">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getAndonContent } from '../../../libs/api'

    export default {
        name: 'andonContentList',
        data() {
            return {
                show: false,
                show1: false,
                show2: false,
                andonTypetVisible: false,
                andonContent: {
                    fcCode: '',
                    acId: '',
                    atId: '',
                    acName: '',
                    acCode: '',
                    isActive: '',
                    checkLevel: '',
                    roleId1: [],
                    roleId2: [],
                    roleId3: [],
                    roleIds: '',
                    roleIdss: '',
                    roleIdsss: ''
                },
                andonTypes: [],
                checkLevels: [1, 2, 3],
                roleList: [],
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                aTypeSelected: '',
                atId: '',
                tableData: [],
                andonTypelist: [],
                level: 0,
                title: '',
                access: [],
                andonRoleShow: false,
                addAndonShow: false,
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                factoryList: [],
                fcCode: ''
            }
        },
        computed: {
            aTList: function() {
                var arr = []
                if (this.andonTypelist != undefined && this.andonTypelist.length > 0) {
                    for (var i = 0; i < this.andonTypelist.length; i++) {
                        arr.push({
                            label: this.andonTypelist[i].typeName,
                            id: this.andonTypelist[i].id,
                            value: this.andonTypelist[i],
                            parent: 0
                        })
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                for (let i = 0; i < this.access.length; i++) {
                    if (this.access[i] == 'A008') {
                        this.andonRoleShow = false
                        break
                    } else {
                        this.andonRoleShow = true
                    }
                }
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getAllFactory()
                this.getAndonTypes()
            },
            getAndonContentOne(acId, fcCode) {
                let options = {
                    method: 'GET',
                    url: this.$api.getAndonContentOne,
                    params: {
                        acId: acId
                    }
                }
                this.$http.request(options).then(response => {
                    this.andonContent = response.data
                    this.andonContent.fcCode = fcCode
                    if (this.andonContent.isActive == '1') {
                        this.andonContent.isActive = true
                    } else if (this.andonContent.isActive == '0') {
                        this.andonContent.isActive = false
                    }
                    if (response.data.roleIds != null && response.data.roleIds != '') {
                        var arr = []
                        var ss = this.andonContent.roleIds.split(',')
                        for (let i = 0; i < ss.length; i++) {
                            arr.push(parseInt(ss[i]))
                        }
                        this.show = true
                        this.$nextTick(() => {
                            this.andonContent.roleId1 = arr
                        })
                    }
                    if (response.data.roleIdss != null && response.data.roleIdss != '') {
                        var arr1 = []
                        var ss1 = this.andonContent.roleIdss.split(',')
                        for (let i = 0; i < ss1.length; i++) {
                            arr1.push(parseInt(ss1[i]))
                        }
                        this.show1 = true
                        this.$nextTick(() => {
                            this.andonContent.roleId2 = arr1
                        })
                    }
                    if (response.data.roleIdsss != null && response.data.roleIdsss != '') {
                        var arr2 = []
                        var ss2 = this.andonContent.roleIdsss.split(',')
                        for (let i = 0; i < ss2.length; i++) {
                            arr2.push(parseInt(ss2[i]))
                        }
                        this.show2 = true
                        this.$nextTick(() => {
                            this.andonContent.roleId3 = arr2
                        })
                    }
                })
            },
            showAndonTypetVisible(acId, fcCode) {
                if (this.fcCode == undefined || this.fcCode == '') {
                    this.$message.error('请选择工厂！')
                    return
                }
                if (acId != null && acId !== undefined) {
                    this.title = '编辑安灯规则'
                    this.getAndonContentOne(acId, fcCode)
                    this.addAndonShow = true
                } else {
                    this.title = '新增安灯规则'
                    this.andonContent = {}
                    this.addAndonShow = false
                    if (this.ischeck) {
                        this.andonContent.fcCode = this.userInfo.fcCode
                    } else {
                        this.andonContent.fcCode = this.fcCode
                    }
                }
                this.andonContent.acId = acId
                this.andonTypetVisible = true
                this.getAndonTypes()
            },
            selectChange() {
                this.$forceUpdate()
            },
            deleteAndonContent(data) {
                let params = {
                    acCode: data.acCode
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getAndonRuleAcCode,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data == undefined || response.data == '') {
                            this.$confirm('此操作将删除种类, 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                let options = {
                                    method: 'POST',
                                    url: this.$api.delAndonContent + data.acId
                                }
                                this.$http.request(options).then(response => {
                                    if (response.status == 100) {
                                        this.$message.success('删除成功!')
                                        this.searchTable()
                                    } else {
                                        this.$message.error('删除失败')
                                    }
                                })

                            })
                        } else {
                            this.$message.error('请先删除安灯规则！')
                        }
                    }
                })

            },
            closeAndonTypet() {
                this.andonContent = {}
                this.andonTypetVisible = false
                this.show = false
                this.show1 = false
                this.show2 = false
            },
            getAndonTypes() {
                /*this.andonTypes = []
                this.roleList = []*/
                let options = {
                    method: 'GET',
                    url: this.$api.getAllAndonType
                }
                this.$http.request(options).then(response => {
                    this.andonTypes = response.data
                })
            },
            getRoleList() {
                var params = {}
                if (this.fcCode != undefined && this.fcCode != '') {
                    params['fcCode'] = this.fcCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getRoleList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    this.roleList = response.data
                })
            },
            checkParam() {
                if (this.andonContent.atId === undefined || this.andonContent.atId === null) {
                    this.$message.error('请选择安灯类型!')
                    return false
                } else if (this.andonContent.acName === undefined || this.andonContent.acName === null) {
                    this.$message.error('请填写安灯种类名称!')
                    return false
                } else if (this.andonContent.acCode === undefined || this.andonContent.acCode === null) {
                    this.$message.error('请填写安灯种类编号!')
                    return false
                } else if (this.andonContent.checkLevel === undefined || this.andonContent.checkLevel === null) {
                    this.$message.error('请选择安灯验收等级!')
                    return false
                }

            },
            addAndonContent() {
                this.searchParams.page = 1
                if (this.checkParam() == false) {
                    return
                }
                var reg = new RegExp('"', 'g')
                if (this.andonContent.roleIds != undefined && this.andonContent.roleId1 != null) {
                    this.andonContent.roleIds = JSON.stringify(this.andonContent.roleId1.join(',')).replace(reg, '')
                }
                if (this.andonContent.roleId2 != undefined && this.andonContent.roleId2 != null) {
                    this.andonContent.roleIdss = JSON.stringify(this.andonContent.roleId2.join(',')).replace(reg, '')
                }
                if (this.andonContent.roleId3 != undefined && this.andonContent.roleId3 != null) {
                    this.andonContent.roleIdsss = JSON.stringify(this.andonContent.roleId3.join(',')).replace(reg, '')
                }
                if (this.addAndonShow == false) {
                    if (this.andonContent.isActive) {
                        this.andonContent.isActive = 1
                    } else {
                        this.andonContent.isActive = 0
                    }
                }
                let options = {
                    method: 'POST',
                    url: this.$api.addAndonContentInsert,
                    data: this.andonContent
                }
                console.log('this.andonContent', this.andonContent)
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.$message.success('编辑成功!')
                        this.searchTable()
                        this.andonTypetVisible = false
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            changeLevel() {
                this.andonContent.roleIds = ''
                this.andonContent.roleIdss = ''
                this.andonContent.roleIdsss = ''
                if (this.andonContent.checkLevel === 1) {
                    this.show = true
                    this.show1 = false
                    this.show2 = false
                } else if (this.andonContent.checkLevel === 2) {
                    this.show = true
                    this.show1 = true
                    this.show2 = false
                } else if (this.andonContent.checkLevel === 3) {
                    this.show = true
                    this.show1 = true
                    this.show2 = true
                }
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            async exportAndonContent() {
                let queryParams = {}
                var self = this
                if (self.aTypeSelected != undefined && self.aTypeSelected != '') {
                    queryParams['atId'] = JSON.parse(self.aTypeSelected).id
                }
                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportAndonContent,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '安灯种类信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            getAllFactory() {
                let options = {
                    method: 'get',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then(response => {
                    this.factoryList = []
                    var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                    var aa = response.data
                    if (this.ischeck) {
                        for (var i = 0; i < aa.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                    this.factoryList.push(aa[i])
                                    this.fcCode = this.userInfo.fcCode
                                }
                            }
                        }
                    } else {
                        this.factoryList = response.data
                    }
                    this.searchTable()
                    // this.getAndonType()
                    this.getRoleList()
                })
            },
            fcChange() {
                // this.aTypeSelected = ''
                // this.andonTypelist = []
                // this.getAndonType()
                this.searchTable()
                this.getRoleList()
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                var self = this
                if (self.atId != undefined && self.atId != '') {
                    queryParams['atId'] = self.atId
                }
                if (self.fcCode != undefined && self.fcCode != '') {
                    queryParams['fcCode'] = self.fcCode
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getAndonContent,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            getAndonType() {
                var params = {}
                if (this.fcCode != undefined && this.fcCode != '') {
                    params['fcCode'] = this.fcCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getAndonRule,
                    params: params
                }
                this.$http.request(options).then(response => {
                    this.andonTypelist = response.data
                })
            }
        }
    }
</script>

<style scoped>
</style>
